import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import "../../static/style/wp-content.css";

class Contact extends Component {
  render() {
    return (
      <div className="row">
        <div className="col-sm-12">
          <h1>
            <FormattedMessage
              id="contact.customerservice"
              defaultMessage="Asiakaspalvelu"
            />
          </h1>
          <p>
            <FormattedMessage
              id="contact.intro"
              defaultMessage="Talousasioissa kannattaa luottaa ammattitaitoon. BRANG tarjoaa vahvaa osaamista ja aina hyväntuulista asiakaspalvelua. Jos sinulla on kysyttävää mistä tahansa palvelustamme, ota yhteyttä! Me olemme täällä sinua varten."
            />
          </p>
          <h2>
            <FormattedMessage
              id="contact.invoice_header"
              defaultMessage="Jos sait meiltä laskun"
            />
          </h2>
          <p>
            <FormattedMessage
              id="contact.hours"
              defaultMessage="Palvelemme arkisin klo 09:00–16:30."
            />
            <br />
            <FormattedMessage id="contact.phone" defaultMessage="Puh:" />
            &nbsp;
            <a href="tel:0400609883">0400 609 883</a>
            <br />
            <a href="mailto:info@brang.fi">info@brang.fi</a>
          </p>
          <h2>
            <FormattedMessage
              id="contact.collection_header"
              defaultMessage="Perintään liittyvät tiedustelut"
            />
          </h2>
          <p>
            <FormattedMessage
              id="contact.hours"
              defaultMessage="Palvelemme arkisin klo 09:00–16:30."
            />
            <br />
            <FormattedMessage id="contact.phone" defaultMessage="Puh:" />
            &nbsp;
            <a href="tel:0400609883">0400 609 883</a>
            <br />
            <a href="mailto:info@brang.fi">info@brang.fi</a>
          </p>
          <h1>BRANG Oy</h1>
          <p>
            Pitkämäenkatu 4 A, 20250 Turku
            <br />
            <a href="mailto:info@brang.fi">info@brang.fi</a>
          </p>
        </div>
      </div>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/containers/static/Contact.js